import React, { useEffect, useState, useCallback } from "react";

const GENESYS_SCRIPT_ID = "genesys-bootstrap-script";
const GENESYS_SCRIPT_SRC =
  "https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js";

/** Región Genesys (ej. prod, mypurecloud.com). */
const environment = "prod";

/**
 * UUID del Messenger deployment.
 * El valor es siempre deploymentId aunque el .env use otro nombre.
 */
const deploymentId = "0c9094c5-d8e4-414f-a4d4-0a889003ce3a";

function loadGenesysBootstrap(env, deployId) {
  if (typeof window === "undefined") return;

  if (!document.getElementById(GENESYS_SCRIPT_ID)) {
    window._genesysJs = "Genesys";
    window.Genesys =
      window.Genesys ||
      function () {
        (window.Genesys.q = window.Genesys.q || []).push(arguments);
      };
    window.Genesys.t = 1 * new Date();
    window.Genesys.c = { environment: env, deploymentId: deployId };

    const script = document.createElement("script");
    script.id = GENESYS_SCRIPT_ID;
    script.async = true;
    script.charset = "utf-8";
    script.src = GENESYS_SCRIPT_SRC;
    document.head.appendChild(script);
  }
}

function GenesysMessenger() {
  const [ready, setReady] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!environment || !deploymentId) return undefined;

    loadGenesysBootstrap(environment, deploymentId);

    const Genesys = window.Genesys;
    if (!Genesys) return undefined;

    Genesys("subscribe", "Messenger.ready", () => {
      setReady(true);
      Genesys("command", "Launcher.hide");
    });
    Genesys("subscribe", "Messenger.opened", () => setOpen(true));
    Genesys("subscribe", "Messenger.closed", () => setOpen(false));

    return undefined;
  }, []);

  const handleOpen = useCallback(() => {
    if (!ready || !window.Genesys) return;
    window.Genesys("command", "Messenger.open");
  }, [ready]);

  if (!environment || !deploymentId) {
    return null;
  }

  if (open) {
    return null;
  }

  return (
    <button
      type="button"
      className="float float-genesys"
      aria-label="Abrir chat en línea"
      disabled={!ready}
      onClick={handleOpen}
    >
      <svg
        className="float-genesys-icon"
        aria-hidden="true"
        viewBox="0 0 24 24"
        width="28"
        height="28"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.2L4 17.2V4h16v12z"
        />
      </svg>
    </button>
  );
}

export default GenesysMessenger;
